import { type QueryHookOptions, useQuery } from '@apollo/react-hooks';
import type { DocumentNode } from 'graphql';
import { getApiClient } from './api-helpers';

export function useApiQuery<T>(
  query: DocumentNode,
  options: QueryHookOptions<T>,
) {
  return useQuery<T, QueryHookOptions>(query, {
    client: getApiClient(),
    ...options,
  });
}
